import { gql, useMutation } from "@apollo/client";

const CREATE_HOMEOWNER_ACCOUNT_MUTATION = gql`
  mutation CreateNewHomeownerAccount(
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $accountType: UserAccountType!
    $phoneNumber: String
    $idempotencyKey: String
    $attribution: AttributionInput
  ) {
    createNewHomeownerAccount(
      email: $email
      password: $password
      firstName: $firstName
      lastName: $lastName
      accountType: $accountType
      phoneNumber: $phoneNumber
      idempotencyKey: $idempotencyKey
      attribution: $attribution
    )
  }
`;

export const useCreateHomeownerAccountMutation = () => {
  const [createHomeownerAccount, { loading, error, data }] = useMutation(
    CREATE_HOMEOWNER_ACCOUNT_MUTATION
  );

  return { createHomeownerAccount, loading, error, data };
}; 
